import { render, staticRenderFns } from "./Terms375.vue?vue&type=template&id=20d38ac8&scoped=true"
import script from "./Terms375.vue?vue&type=script&lang=js"
export * from "./Terms375.vue?vue&type=script&lang=js"
import style0 from "./Terms375.vue?vue&type=style&index=0&id=20d38ac8&prod&lang=css&scoped=true"
import style1 from "./Terms375.vue?vue&type=style&index=1&id=20d38ac8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d38ac8",
  null
  
)

export default component.exports